import styled from "styled-components";

export const PageContainer = styled.div`
  width: 100%;
  padding: 24px 24px 48px;
  box-sizing: border-box;
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 28px;
  color: #212121;
`;

export const Subtitle = styled.p`
  margin: 0;
  font-size: 14px;
  color: #616161;
`;

export const TabsCard = styled.div`
  background: #fff;
  border-radius: 16px;
  border: 1px solid #ededed;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
  overflow: hidden;

  .MuiAppBar-root {
    background: #fff;
    color: #212121;
    box-shadow: none;
    border-bottom: 1px solid #f0f0f0;
  }

  .MuiTabs-indicator {
    background-color: #ed4e2a;
  }

  .MuiTab-root {
    text-transform: none;
    font-weight: 600;
    font-size: 14px;
    min-height: 48px;
  }

  .MuiTab-root.Mui-selected {
    color: #ed4e2a;
  }
`;

export const TabPanelContainer = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-sizing: border-box;
`;

export const SectionTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  color: #212121;
`;

export const SectionHint = styled.p`
  margin: 0;
  font-size: 13px;
  color: #7a7a7a;
`;

export const SectionCard = styled.div`
  background: #fff;
  border-radius: 14px;
  border: 1px solid #eeeeee;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.06);
  width: 100%;
  box-sizing: border-box;

  .MuiFormControl-root,
  .ra-input,
  .ra-input > div,
  .ra-input > span {
    width: 100%;
  }

  .MuiInputBase-root,
  .MuiFilledInput-root,
  .MuiInput-root,
  .MuiOutlinedInput-root {
    width: 100%;
  }

  div.tabContainer {
    width: 100%;
  }
`;

export const FormStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const PhoneInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  label {
    font-size: 12px;
    font-weight: 600;
    color: #616161;
  }

  .react-tel-input {
    background: #f5f5f5;
    padding: 8px 0;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    margin: 0;
  }

  .react-tel-input .form-control {
    background: none;
    border: none;
    font-size: 14px;
  }
`;

export const PaymentList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PaymentItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
`;

export const PaymentInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  img {
    height: 28px;
  }
`;
